import React from 'react'

import { hooks, I18n } from '@front/volcanion'
import { OptionUtils } from '@front/volcanion/utils'

import { DialogContentText } from '@mui/material'

const ValidateForceOptions = ({ driver_options_not_allowed, vehicle_options_not_allowed }) => {
  const [driver_opts] = hooks.useModel('useroption', driver_options_not_allowed)
  const [vehicle_opts] = hooks.useModel('vehicleoption', vehicle_options_not_allowed)
  const options = _.join(_.map(_.flatten([driver_opts, vehicle_opts]), OptionUtils.getLabel), ', ')
  return (
    <DialogContentText>{I18n.t('order.popup.unauthorized_options.description', { options })}</DialogContentText>
  )
}

export default ValidateForceOptions
